import list from './list';
import upsert from './upsert';
import read from './read';

export default {
  namespaced: true,
  modules: {
    list,
    upsert,
    read,
  },
};
